module.exports = __webpack_public_path__ + "static/VastraHamnenSvartVit-39c1be9186794df817cfa63fe569184a.png";